import React from "react";
import { useParams } from "react-router-dom";

import { useOrganization } from "context/OrganizationContext";
import { useSite } from "context/SiteContext";

import styles from "./FooterSection.module.scss";
import SectionWrapper from "components/elements/SectionWrapper";

import LazyImage from "components/elements/LazyImage/LazyImage";
import SmartLink from "components/SmartLink";

const FooterSection = (props) => {
	const { alignment, order, short_desc, text_color_title } = props;

	const organization = useOrganization();
	const site = useSite();
	const { org_url } = useParams();

	const handleFooterAnchor = (e, targetId) => {
		e.preventDefault();
		const targetElement = document.getElementById(targetId);
		if (targetElement) {
			targetElement.scrollIntoView({ behavior: "smooth" });
		}
	}; // Extract social links from urls
	const socialLinks =
		organization?.urls
			?.filter((url) => url?.type?.name && url?.url)
			.map((url) => ({
				name: url.type.name,
				url: url.url,
			})) || [];

	// Contact information
	const contact = {
		email: organization?.email,
		phone: organization?.fon,
		website: organization?.website,
	};

	// Address information
	const address = {
		street: organization?.streetAddress,
		postalCode: organization?.postalcode,
		city: organization?.city,
	};

	// Get logo from medias
	const logo = organization?.ci?.logo[0]?.mediaUrl || organization?.logos[0]?.mediaUrl || "";
	const alignmentClass = alignment ? "text-" + alignment : "";	return (
		<>
			{site?.footer && site.footer.trim() !== "" ? (
				<footer dangerouslySetInnerHTML={{ __html: site.footer }} />
			) : (
				<SectionWrapper
					className={`${styles.FooterSection} pt-5`}
					fluid={false}
					show_header={false}
					{...props}>
					<footer>
						<div className={`row ${order === "backwards" ? "flex-row-reverse" : ""}`}>
							{/* Linke Spalte */}
							<div className="col mb-4 mb-md-0">
								{logo ? (
									<LazyImage
										src={logo}
										alt={`${organization?.name} Logo`}
										className="w-75"
										classNameWrapper="mb-4"
										disableAbsolute={true}
									/>
								) : (
									<span className="navbar-brand fw-bold">{organization?.title}</span>
								)}
								<p className="text-uppercase line-wrap fs-5 fw-bold mb-2">{organization?.name}</p>
								<p>{organization?.slogan}</p>
								<p>
									{address.street} <br /> {address.postalCode} {address.city}
								</p>
							</div>
							{/* Mittlere Spalte */}
							<div className="col mb-4 mb-md-0">
								<p className="text-uppercase fs-5 fw-bold mb-2">Navigation</p>
								<ul className="list-unstyled">
									{site?.navigation?.items
										?.filter((item) => item.show_in_footer)
										.map((item) => {
											const link = item.page ? `/${org_url}/${site.unique_url}/${item.page.unique_url}` : item.url;
											const isAnchor = item.url && item.url.startsWith("#");

											return (
												<li
													className="nav-item"
													key={item.id}>
													<SmartLink
														to={link}
														className="nav-link"
														onClick={isAnchor ? (e) => handleFooterAnchor(e, item.url.substring(1)) : undefined}>
														{item.title}
														{isAnchor && <span className="nav-border" />}
													</SmartLink>
												</li>
											);
										})}
								</ul>
							</div>

							{/* Rechte Spalte */}
							<div className="col mb-4 mb-md-0">
								<p className="text-uppercase fs-5 fw-bold mb-2">Kontakt</p>
								{contact.email && (
									<p className="mb-1">
										E-Mail: <SmartLink to={`mailto:${contact.email}`}>{contact.email}</SmartLink>
									</p>
								)}
								{contact.phone && <p className="mb-1">Telefon: {contact.phone}</p>}
								{contact.website && (
									<p className="mb-1">
										Webseite: <SmartLink to={`https://${contact.website}`}>{contact.website}</SmartLink>
									</p>
								)}
								{socialLinks.length > 0 && (
									<>
										<p className="text-uppercase mt-4 fs-5 fw-bold mb-2">Social Media</p>
										<ul className="list-unstyled d-flex justify-content-start">
											{socialLinks.map((link, index) => (
												<li
													key={index}
													className="me-3">
													<SmartLink
														to={link.url}
														target="_blank"
														rel="noreferrer">
														{link.name}
													</SmartLink>
												</li>
											))}
										</ul>
									</>
								)}
							</div>
							<div className="col mb-4 mb-md-0">
								<p className={`title ${alignmentClass} text-uppercase fs-5 fw-bold mb-2`}>Über uns</p>

								{organization?.short_desc && <p className={`lead ${alignmentClass}`}>{short_desc}</p>}
								{organization?.desc && (
									<p
										className={`desc ${alignmentClass}`}
										dangerouslySetInnerHTML={{ __html: organization.desc }}></p>
								)}
							</div>
						</div>
						<hr style={text_color_title && { borderColor: text_color_title }} />
						<div className="text-center">
							© {new Date().getFullYear()} {organization?.name} – Alle Rechte vorbehalten.
						</div>
					</footer>
				</SectionWrapper>
			)}
		</>
	);
};

export default FooterSection;
